
import {BrowserRouter, Routes, Route } from "react-router-dom";
import Swiper from 'swiper';
import 'swiper/css';
import ScrollToTop from "./component/layout/scrolltop";
import AboutPage from "./pages/about";
import AchievementPage from "./pages/achievement";
import BlogPage from "./pages/blog";
import BlogDetails from "./pages/blog-single";
import BlogPageTwo from "./pages/blogtwo";
import ContactUs from "./pages/contact";
import GalleryPage from "./pages/gallery";
import GameListSection from "./pages/gamelist";
import GameListTwoSection from "./pages/gamelisttwo";
import HomePage from './pages/home';
import HomeTwo from './pages/hometwo';
import LogIn from "./pages/login";
import PartnerPage from "./pages/partner";
import ShopPage from "./pages/shop";
import ShopCart from "./pages/shopcart";
import ShopDetails from "./pages/shopdetails";
import SignUp from "./pages/signup";
import TeamPage from "./pages/team";
import TeamSinglePage from "./pages/team-single";
import ErrorPage from "./pages/errorpage";
import ShopPageSticker from "./pages/shop-sticker";
import ShopPageBeanie from "./pages/shop-beaniehat";
import ShopPageShirt from "./pages/shop-shirt";
import ShopPageJersey from "./pages/shop-jersey";
import ShopPageMerch from "./pages/shop-signedmerch";
import ShopPageMousepad from "./pages/shop-mousepad";
import ShopPageHoodie from "./pages/shop-hoodie";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ShopContextProvider from "./context/ShopContext";
import PlaceOrder from "./pages/PlaceOrder";
import CartTotal from "./component/section/CartTotal";
import Orders from "./pages/Orders";
import Verify from "./pages/Verify";
import UserProfile from "./pages/UserProfile";






// import Footer from "./component/layout/footer";
// import Header from "./component/layout/header";
// import PageHeader from './component/layout/pageheader';
// import GameList from './component/section/gamelist';


function App() {
	return (
		// <div className="App">
		// 	<ShopPage />
		// </div>
		<>


				<ScrollToTop />
					<Routes>
						<Route path="/" element={<HomePage />} />
						
						<Route path="about" element={<AboutPage />} />
						
						
						
						
						
						
						<Route path="team/:slug" element={<TeamSinglePage />} />
						<Route path="*" element={<ErrorPage />} />
						<Route path="shop" element={<ShopPage />} />
						<Route path="place-order" element={<PlaceOrder />} />
						
						<Route path="verify" element={<Verify />}></Route>

						<Route path="shop-beaniehat" element={<ShopPageBeanie />} />
						<Route path="shop-shirt" element={<ShopPageShirt />} />
						<Route path="shop-sticker" element={<ShopPageSticker />} />
						<Route path="shop-jersey" element={<ShopPageJersey />} />
						<Route path="shop-signedmerch" element={<ShopPageMerch />} />
						<Route path="shop-mousepad" element={<ShopPageMousepad />} />
						<Route path="shop-hoodie" element={<ShopPageHoodie />} />


						<Route path="orders" element={<Orders />} />
						<Route path="shop-single/:productId" element={<ShopDetails />} />
						<Route path="cart-page" element={<ShopCart />} />
						<Route path="blog" element={<BlogPage />} />
						
						
						<Route path="contact" element={<ContactUs />} />
						<Route path="login" element={<LogIn />} />
						<Route path="signup" element={<SignUp />} />
						<Route path="profile" element={<UserProfile/>} />
						
					</Routes>

			<ToastContainer/>

			</>

		
	);
}

export default App;
